import React, { Component } from 'react';
import {Route, Link} from 'react-router-dom';

import './NanumSquare.scss';

class NanumSquare extends Component {
  render() {
    const {input, onChange} = this.props;

    return (
      <li>
        <Link to="/nanum_square/detail">
          <div className="dashed-wrap nanum_square">
            <h4 className="content-title">
              <span className="font-company">Naver, Sandoll</span>
              <span className="font-title">나눔스퀘어 / Nanum Square</span>
            </h4>
            <p className="font-text">{input}</p>
          </div>
        </Link>
      </li>
    );
  }
}

export default NanumSquare;